const tabs = () => {
  const $tabLinks = document.querySelectorAll('.tablist__link');
  const $tablistToggle = document.querySelector('.tablist__toggle');
  const tablistPanelID = $tablistToggle.getAttribute('aria-controls');
  const $tablistPanel = document.getElementById(tablistPanelID);
  const mobileQuery = window.matchMedia(`(max-width: ${window.theme.breakpoints.medium}px)`);
  let isExpanded = true;

  const handleTabClick = e => {
    const target = e.target;

    if (target.getAttribute('aria-selected') === 'true') {
      return;
    }

    const tabPanelID = target.getAttribute('aria-controls');
    const $tabPanel = document.getElementById(tabPanelID);

    // Hide the tab that is open
    const $activeTabPanel = document.querySelector('.tabcontent[aria-hidden=false]');
    if ($activeTabPanel) {
      $activeTabPanel.setAttribute('aria-hidden', true);
    }

    // Update tablink aria-selected attribute as it's no longer active
    const $activeTabLink = document.querySelector('.tablist__link[aria-selected=true]');
    if ($activeTabLink) {
      $activeTabLink.setAttribute('aria-selected', false);
    }

    // Activate tablink & tab
    $tabPanel.setAttribute('aria-hidden', false);
    target.setAttribute('aria-selected', true);

    // On mobile, update the tablistToggle text & close dropdown
    if ($tablistToggle) {
      $tablistToggle.querySelector('span').textContent = target.textContent;
    }

    if (mobileQuery.matches) {
      toggleTablinks();
    }
  };

  const toggleTablinks = () => {
    isExpanded = !isExpanded;
    $tablistToggle.setAttribute('aria-expanded', isExpanded);
    $tablistPanel.setAttribute('hidden', !isExpanded);
  };

  const handleResize = e => {
    if (e.matches) {
      $tablistPanel.setAttribute('hidden', true);
      isExpanded = false;
    } else {
      $tablistToggle.setAttribute('aria-expanded', false);
      $tablistPanel.removeAttribute('hidden');
      isExpanded = true;
    }
  };

  if (mobileQuery.matches) {
    $tablistPanel.setAttribute('hidden', true);
    isExpanded = false;
  }

  // Change tabs when a tablink is cliked
  if ($tabLinks.length > 0) {
    $tabLinks.forEach(tabLink => {
      tabLink.addEventListener('click', e => {
        handleTabClick(e);
      });
    });
  }

  // Toggle tablinks dropdown on mobile
  if ($tablistToggle) {
    $tablistToggle.addEventListener('click', toggleTablinks);
  }

  // Media query status change (window resize)
  //window.addEventListener('resize', handleResize);
  mobileQuery.addListener(e => {
    handleResize(e);
  });
};

export default tabs;
